<template>
  <div id="studentRegist" style="position:absolute;top:-10000px;left:-5000px">
    <ul
      class="student_regist"
      v-for="(temp,num) in getShowTotal"
      :key="num"
      style="display:flex;flex-wrap:wrap;list-style:none;page-break-after:always;margin:100px 0 0 0;padding:0 0;"
    >
      <li
        v-for="(item,index) in list.slice(num * 9,(num + 1)*9)"
        :key="num + '_'+ index"
        style="border: 1px solid #979797;width: 27%;padding: 30px 10px 20px 20px;margin: 0 0 30px 30px;"
      >
        <section class="head_img" style="width:100px;height:140px;margin:0 auto;">
          <img style="width:100%;height:100%" :src="item.headImage" alt />
        </section>
        <section
          class="student_info_box"
          style="display: flex;justify-content: space-between;margin-top: 20px;color: #444;"
        >
          <ul class="student_info_left" style="width: 100%;margin:0;padding:0;">
            <li style="font-size: 14px;display: flex;align-items:flex-start;margin:0 0 10px 0;">
              <p class="left_width" style="flex: 1;margin:0;">
                姓名
                <span style="font-size: 10px;font-weight: 400;">{{item.name}}</span>
              </p>
              <p class="right_width" style="width:170px;margin:0;">
                性别
                <span style="font-size: 10px;font-weight: 400;">{{!item.gender?'女':'男'}}</span>
              </p>
            </li>
            <li style="font-size: 14px;margin-bottom: 10px;display: flex;align-items: flex-start;">
              <p class="left_width" style="flex: 1;margin:0;">
                民族
                <span style="font-size: 10px;font-weight: 400;">{{item.nation}}</span>
              </p>
              <p class="right_width" style="width:170px;margin:0;">
                出生
                <span style="font-size: 10px;font-weight: 400;">{{item.birthday}}</span>
              </p>
            </li>
            <li style="font-size: 14px;margin-bottom: 10px;display: flex;align-items: flex-start;">
              <p style="margin:0;padding:0">
                学校
                <span style="font-size: 10px;font-weight: 400;">{{item.schoolName}}</span>
              </p>
            </li>
            <li style="font-size: 14px;margin-bottom: 10px;display: flex;align-items: flex-start;">
              <p class="left_width" style="flex: 1;margin:0;">
                专业
                <span style="font-size: 10px;font-weight: 400;">{{item.major}}</span>
              </p>
              <p class="right_width" style="width:170px;margin:0;">
                学制
                <span
                  style="font-size: 10px;font-weight: 400;"
                >{{schoolSystem(item.schoolSystem)}}</span>
              </p>
            </li>
            <li style="font-size: 14px;margin-bottom: 10px;display: flex;align-items: flex-start;">
              <p class="left_width" style="flex: 1;margin:0;">
                组别
                <span style="font-size: 10px;font-weight: 400;">{{registGroup(item.group)}}</span>
              </p>
              <p class="right_width" style="width:170px;margin:0;">
                类别
                <span style="font-size: 10px;font-weight: 400;">{{item.type === 1?'阳光体育':'竞技项目'}}</span>
              </p>
            </li>
            <li style="font-size: 14px;margin-bottom: 10px;display: flex;align-items: flex-start;">
              <p style="margin:0;">
                首次注册时间
                <span style="font-size: 10px;font-weight: 400;">{{item.startSchoolDate}}</span>
              </p>
            </li>
            <li style="font-size: 14px;margin-bottom: 10px;display: flex;align-items: flex-start;">
              <p style="margin:0;">
                注册号
                <span style="font-size: 10px;font-weight: 400;">{{item.registerNumber}}</span>
              </p>
            </li>
            <li style="font-size: 14px;margin-bottom: 10px;display: flex;align-items: flex-start;">
              <p style="margin:0;">
                有效期
                <span
                  style="font-size: 10px;font-weight: 400;"
                >{{effectiveTime(item.startSchoolDate,item.endSchoolDate)}}</span>
              </p>
            </li>
          </ul>
        </section>
      </li>
    </ul>
  </div>
</template>
<script>
import { method } from "@/utils/utils";
import registerData from "@/assets/json/register.json";
import { getSession } from "@/utils/storage";
export default {
  props: {
    list: {
      type: Array
    }
  },
  data() {
    return {
      schoolName: JSON.parse(getSession("userInfo")).schoolName || ""
    };
  },
  computed: {
    // 打印，固定每页显示4个，根据list长度，获取显示总页数
    getShowTotal() {
      let num = 0;
      let length = this.list.length;
      if (length <= 9) num = 1;
      else {
        if (length / 9 > parseInt(length / 9)) {
          num = parseInt(length / 9) + 1;
        } else {
          num = parseInt(length / 9);
        }
      }
      return num;
    },
    // 筛选学制
    schoolSystem() {
      return data => {
        let label = "";
        registerData.educationalList.filter(item => {
          if (item.value === data) {
            label = item.label;
          }
        });
        return label;
      };
    },
    // 筛选组别
    registGroup() {
      return data => {
        let label = "";
        registerData.registGroup.filter(item => {
          if (item.value === data) {
            label = item.label;
          }
        });
        return label;
      };
    },
    // 有效期
    effectiveTime() {
      return (data, end) => {
        return data + " 至 " + end;
      };
    }
  }
};
</script>
<style lang="less" scoped>
</style>